import React, { FC } from 'react'
import classNames from 'classnames'
import { Tabs as AntdTabs, TabsProps as AntdTabsProps } from 'antd'
import { TabsType as AntdTabType } from 'antd/es/tabs'
import styles from './index.less'

type BaseTabsProps = Omit<AntdTabsProps, 'type'>

type ExtendedTabsType = 'primary-line' | 'primary-card'

export type TabsType = AntdTabType | ExtendedTabsType

const tabsTypeMap: Partial<Record<TabsType, AntdTabType>> = {
    'primary-line': 'line',
    'primary-card': 'card'
}

export interface TabsProps extends BaseTabsProps {
    type?: TabsType
}

export const Tabs: FC<TabsProps> = props => {
    const { type, size, className, tabPosition, children, ...restProps } = props

    const tabsType = type && tabsTypeMap[type] ? tabsTypeMap[type] : (type as AntdTabType)

    const tabsClassName = classNames(
        {
            [styles.tabsPrimaryLine]: type === 'primary-line',
            [styles.tabsPrimaryCard]: type === 'primary-card',
            [styles.topPosition]: (type === 'primary-card' && !tabPosition) || tabPosition === 'top'
        },
        className
    )

    return (
        <AntdTabs className={tabsClassName} type={tabsType} size={size} {...restProps}>
            {children}
        </AntdTabs>
    )
}
